<!-- 搜索栏 -->
<template>
    <!-- <el-autocomplete
        v-model="searchKey"
        :fetch-suggestions="querySearch"
        :placeholder="placeholder"
        :trigger-on-focus="false"
        @select="handleSelect">
        <div class="searchIcon" slot="suffix" @click="handleIconClick">
            <i class="iconfont icon-iconfont_search"></i>
        </div>
        <template slot-scope="{ item }">
            <div class="name">{{ item.value }}</div>
        </template>
    </el-autocomplete> -->
    <el-input :placeholder="placeholder" v-model="searchKey" class="input-with-select" :class="{'big':size=='big'}">
        <div class="searchIcon" slot="suffix" @click="handleIconClick(searchKey)">
            <i class="iconfont icon-iconfont_search"></i>
        </div>
    </el-input>
</template>

<script>
    export default {
        data() {
            return {
                searchKey:'',//搜索关键字
            }
        },
        props:{
            placeholder:{
                type:String,
                default(){
                    return '请输入土地名称、城市、受让方关键字搜索';
                }
            },
            size:{
                type:String,
                default(){
                    return 'normal';
                }
            },
        },
        watch: {
            searchKey(newVal,oldVal){
                // console.log('newVal:'+newVal,'oldVal:'+oldVal)
                if(!newVal&&oldVal){//搜索关键字清空时
                    this.$emit('handleIconClick',this.searchKey);
                }
            }
        },
        methods: {
            handleIconClick(key) {
                console.log(key);
                this.$emit('handleIconClick',key);
            },
            //===============================以上为带联想的输入搜索（备用）==================================

            //搜索
            querySearch(queryString, cb) {
                console.log(queryString, this.list)
                const list = [
                    { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
                    { "value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号" },
                    { "value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
                    { "value": "泷千家(天山西路店)", "address": "天山西路438号" },
                    { "value": "胖仙女纸杯蛋糕（上海凌空店）", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101" },
                    { "value": "贡茶", "address": "上海市长宁区金钟路633号" },
                    { "value": "豪大大香鸡排超级奶爸", "address": "上海市嘉定区曹安公路曹安路1685号" },
                    { "value": "茶芝兰（奶茶，手抓饼）", "address": "上海市普陀区同普路1435号" },
                    { "value": "十二泷町", "address": "上海市北翟路1444弄81号B幢-107" }
                ];
                var results = queryString ? list.filter(this.createFilter(queryString)) : list;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            // 搜索匹配规则
            createFilter(queryString) {
                return (developer) => {
                    return (developer.value.indexOf(queryString) != -1);
                };
            },
            // 选择搜索选项
            handleSelect(item){
                console.log(item)
            },

            
        }
    }
</script>

<style lang="scss" scoped>
.big{
    width:4rem!important;
}
</style>
